import React from 'react';

const Learn = () => {
  return (
    <div>Learn</div>
  )
}

export default Learn;